import { GoogleLocationData } from './google-location-data';

export interface GooglePlaceApiResponse {
  html_attributions: any[];
  result: GoogleLocationData;
  status: string;
}
